<template>
  <div class="main-content">
    <!-- CARDS -->
    <div class="container-fluid">
      <!-- / .row -->
      <div class="row">
        <div class="col-12">
          <!-- Convertions -->
          <div class="card mt-5">
            <div class="card-header">
              <!-- Title -->
              <h4 class="card-header-title">Job Readiness Data</h4>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-end mb-3">
                <label class="align-self-center mb-0 mr-3">Search</label>
                <b-form-input v-model="searchTerm" class="w-auto" placeholder="Type Here..."></b-form-input>
              </div>
              <vue-good-table
                :columns="columns"
                :rows="list"
                :line-numbers="true"
                :search-options="{
                  enabled: true,
                  externalQuery: searchTerm,
                }"
                @on-sort-change="onSortChange"
                :pagination-options="{
                  enabled: true,
                  perPage: pageLength,
                }">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'created_at'">
                    {{ formatDate(props.row.created_at) }}
                  </span>
                  <span v-else-if="props.column.field == 'updated_at'">
                    {{ formatDate(props.row.updated_at) }}
                  </span>
                  <div
                    v-else-if="props.column.field == 'action'"
                    class="text-center"
                  >
                    <button
                      class="btn btn-sm btn-warning me-2"
                      v-b-modal.detail-data
                      @click="showDetail(props.row)"
                    >
                      Detail
                    </button>
                  </div>
                </template>
                <template slot="pagination-bottom" slot-scope="props">
                  <div class="d-flex justify-content-end">
                    <div>
                      <b-pagination
                        :value="1"
                        :total-rows="props.total"
                        :per-page="pageLength"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="m-3"
                        @input="(value) => props.pageChanged({ currentPage: value })"
                      >
                      </b-pagination>
                    </div>
                  </div>
                </template>

              </vue-good-table>

            </div>
          </div>
        </div>
      </div>
      <!-- / .row -->
    </div>
    <!-- MODAL -->
    <b-modal
      id="detail-data"
      ref="detail-modal-ref"
      centered
      title="Detail Job Readiness"
      hide-footer
    >
      <b-row>
        <b-col>
          <label>Name</label>
          <p><b>{{ detail.user_name }}</b></p>
        </b-col>
        <b-col>
          <label>Location</label>
          <p><b>{{ detail.location_name }}</b></p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Drug Consumption</label>
          <p><b>{{ detail.drug_consumption ? 'YES' : 'NO' }}</b></p>
        </b-col>
        <b-col>
          <label>Personal Problem</label>
          <p><b>{{ detail.personal_problems ? 'YES' : 'NO' }}</b></p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Response Check</label>
          <p><b>{{ detail.employee_response_check ? 'YES' : 'NO' }}</b></p>
        </b-col>
        <b-col>
          <label>Concentration Check</label>
          <p><b>{{ detail.employee_concentration_check ? 'YES' : 'NO' }}</b></p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Health Check</label>
          <p><b>{{ detail.employee_health_checkup ? 'YES' : 'NO' }}</b></p>
        </b-col>
      </b-row>
    </b-modal>
  </div>
  <!-- / .main-content -->
</template>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import moment from "moment";

export default {
  name: "JobReadinessList",
  computed: {
    columns() {
      return this.$store.getters["jobReadiness/columns"];
    },
    list() {
      return this.$store.getters["jobReadiness/list"];
    },
  },
  data() {
    return {
      searchTerm: "",
      pageLength: 10,
      params: {},
      detail: {
        user_name: '',
        long_hours_of_sleep: '',
        drug_consumption: '',
        personal_problems: '',
        employee_response_check: '',
        employee_concentration_check: '',
        employee_health_checkup: '',
        employee_ready_to_work: '',
        location_name: '',
      }
    };
  },
  mounted() {
    console.log(this);
    this.getList();
  },
  methods: {
    getList() {
      this.$store.dispatch("jobReadiness/GET_LIST");
    },
    onSortChange(params) {
      // this.updateParams({
      //   sort: [{
      //     type: params.sortType,
      //     field: this.columns[params.columnIndex].field,
      //   }],
      // });
      // this.loadItems();
      console.log('onSortChange params', params);
    },
    onColumnFilter(params) {
      // this.updateParams(params);
      // this.loadItems();
      console.log('onColumnFilter params', params);
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("YYYY/MM/DD HH:mm:ss");
      }
      return date;
    },
    showDetail(data) {
      this.detail = data
    },
    remove(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("location/DELETE", { id: id }).then(() => {
            this.$swal("Deleted!", "Location Deleted!.", "success");
            this.getList();
          });
        }
      });
    },
  },
};
</script>
